import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { buildWaiter } from '@ember/test-waiters';

let waiter = buildWaiter('device-model-service:import-waiter');

export default class DevicesService extends Service {
  @tracked
  Devices: typeof import('@customerio/devices') | null = null;

  load = task(async () => {
    let token = waiter.beginAsync();
    this.Devices = await import('@customerio/devices');
    waiter.endAsync(token);
  });

  getMarketingName(model: string | null): string {
    if (this.Devices == null) {
      return model ?? '';
    }
    if (model == null) {
      return '';
    }
    return this.Devices.getMarketingName(model) ?? model;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    devices: DevicesService;
  }
}
